export function getScriptRoot() {
    const url = new URL(document.currentScript?.src ?? '');
    return url.href.split('/').slice(0, -1).join('/');
}
